import React from 'react';
import { Award, Star, ShieldCheck, BadgeCheck } from 'lucide-react';
export function BrandsStrip() {
  const badges = [{
    Icon: Award,
    title: 'Owens Corning',
    sub: 'Preferred Contractor'
  }, {
    Icon: BadgeCheck,
    title: 'CertainTeed',
    sub: 'Quality Made Certain'
  }, {
    Icon: ShieldCheck,
    title: 'Licensed & Insured',
    sub: 'State of Michigan'
  }, {
    Icon: Star,
    title: 'Top-Rated',
    sub: 'By Michigan Homeowners'
  }];
  return <section className="bg-slate-50 border-y border-slate-200 py-8 sm:py-10" data-id="element-19" data-mp="29q0lr8avdhxw">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-20" data-mp="24xqnn4zlpbkj">
        <p className="text-center text-xs sm:text-sm uppercase tracking-[0.2em] text-slate-500 font-bold mb-6" data-id="element-21" data-mp="1zzp46iy9ja8j">
          Certified, Insured, and Trusted by Michigan Homeowners
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6" data-id="element-22" data-mp="2xgwb7yrus11z">
          {badges.map(({
          Icon,
          title,
          sub
        }) => <div key={title} className="flex items-center gap-3 sm:gap-4 bg-white border border-slate-200 rounded-xl px-4 py-3 shadow-sm" data-id="element-23" data-mp="3s4jjvzx2o4li">
              <div className="flex-shrink-0 w-12 h-12 rounded-full bg-[#2DB8E0]/10 flex items-center justify-center" data-id="element-24" data-mp="3if9pgdera9u8">
                <Icon className="w-6 h-6 text-[#2DB8E0]" data-id="element-25" data-mp="3ndtcyi8zztop" />
              </div>
              <div className="min-w-0" data-id="element-26" data-mp="38h2c04joe9wz">
                <div className="font-bold text-[#1a2332] text-sm sm:text-base leading-tight" data-id="element-27" data-mp="38g0zdvn0hfd5">
                  {title}
                </div>
                <div className="text-xs sm:text-sm text-slate-500 leading-tight" data-id="element-28" data-mp="3de2lyqjnbwtd">
                  {sub}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}